<template>
<div class="AssociateGroupCourseDiv">
   <div class="container-fluid">
      <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="text-right close-text-font-style margin-right-1Point5Perc margin-Top-1Point5Perc cursor-pointer" v-on:click="updateShowAssociateGroupCourseOverlayFlag($event,false)">
                    <img src= "../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  Course
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <select class="form-control" v-model="getSelectedCourseObjValue">
                        <option value='-1' disabled>Select</option>
                        <option v-for="courseObj in getCourseList" v-bind:key="courseObj.CourseMasterId" v-bind:value="courseObj">{{ courseObj.CourseTitle }} {{courseObj.SubTitle === null || courseObj.SubTitle.trim() === ''? '' : '[' + courseObj.SubTitle + ']'}}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  Group
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <select class="form-control" v-model="selectedGroupObj">
                        <option value='-1' disabled>Select</option>
                        <option v-for="groupObj in getGroupList" v-bind:key="groupObj.GroupId" v-bind:value="groupObj">{{ groupObj.GroupName }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  Display Title
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <input type="text" class="form-control" id="usr" v-model="displayTitle" :maxlength="display_title_maxLength">
                    </div>
                  </div>
                </div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  Display Sub-Title
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <input type="text" class="form-control" id="usr" v-model="displaySubTitle" :maxlength="display_sub_title_maxLength">
                    </div>
                  </div>
                </div>
              </div>
            <div v-if="selectedCourseObj !== -1 && selectedCourseObj.CourseMasterId !== constants.Default_Meeting_Mentor_Course">
              <div class="row vertical-align margin-bottom-2Perc" v-if="selectedCourseObj !== -1 && selectedCourseObj.Type !== constants.CourseType.RecommendationAssessment">
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                    Anonymised R&D's:
                </div>
                <div class="col-lg-4 col-md-4">
                  <div class="form-group text-align-left">
                    <div class="col-sm-12">
                      <input type="checkbox" v-model="anonymisedValue"/>
                    </div>
                  </div>
                </div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px padding-Left-0px">
                </div>
                <div class="col-lg-4 col-md-4">
                  <div class="form-group text-align-left">
                    <div class="col-sm-4"></div>
                  </div>
                </div>
              </div>
              <!-- START Custom Alert Message -->
              <div class="row vertical-align margin-bottom-2Perc" v-if="selectedCourseObj !== -1 && selectedCourseObj.Type !== constants.CourseType.RecommendationAssessment">
                <!-- <div class="col-md-1 col-lg-1"></div> -->
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Custom Alert Message
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <textarea class="form-control" rows="3" v-model="alertMessage" maxlength="1024" placeholder="Max 1024 characters" :disabled="electiveCourseValue || isM365Course"></textarea>
                    </div>
                  </div>
                </div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  Elective Course
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <input type="checkbox" class="float-left" v-model="electiveCourseValue" :disabled="disableIsElectiveCheckbox"/>
                    </div>
                  </div>
                </div>
              </div>
              <!-- END Custom Alert Message -->
              <!-- START Elective Course -->
              <!-- <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Elective Course:
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <input type="checkbox" class="float-left" v-model="electiveCourseValue" :disabled="disableIsElectiveCheckbox"/>
                    </div>
                  </div>
                </div>
                <div class="row col-md-4 col-lg-4"></div>
              </div> -->
              <!-- END Elective Course -->
              <!-- SS: Start Release TS & Expiry Days -->
              <div class="row vertical-align margin-bottom-2Perc" v-if="selectedCourseObj !== -1 && selectedCourseObj.Type !== constants.CourseType.RecommendationAssessment">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  Release Date
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <date-picker v-model="setDateValue" :config="config" :disabled="date === null || date === undefined || date === '' || date === 'null'"></date-picker>
                    </div>
                  </div>
                </div>
                <div class="create-lesson-input-text-style col-lg-1 col-md-1 text-align-right padding-right-0Px">
                  Expiry Days
                </div>
                <div class="col-lg-2 col-md-2">
                  <div class="form-group text-align-left">
                    <div class="col-sm-12">
                      <input type="number" class="form-control" v-model="expiryDaysValue" min="0" max="999">
                    </div>
                  </div>
                </div>
              </div>

              <div class="row vertical-align margin-bottom-2Perc" v-if="selectedCourseObj !== -1 && selectedCourseObj.Type !== constants.CourseType.RecommendationAssessment">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  {{this.completionCriteriaTextLabel}}
                </div>
                <div class="col-lg-2 col-md-2">
                  <div class="form-group text-align-left">
                    <div class="col-sm-12">
                      <input type="number" class="form-control" v-model="setCompletionCriteriaForElectivesValue" min="0" max="100">
                    </div>
                  </div>
                </div>
                <div class="col-lg-2 col-md-2">
                  <div class="form-group text-align-left">
                  </div>
                </div>
                <div class="create-lesson-input-text-style col-lg-1 col-md-1 text-align-right padding-right-0Px"> 
                </div>
                <div class="col-lg-2 col-md-2">
                  <div class="form-group text-align-left">
                    <div class="col-sm-12">
                    </div>
                  </div>
                </div>
              </div> 


              <div class="row vertical-align margin-bottom-2Perc" v-if="selectedCourseObj !== -1 && selectedCourseObj.Type !== constants.CourseType.RecommendationAssessment">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  Completion Criteria for Certificate
                </div>
                <div class="col-lg-2 col-md-2">
                  <div class="form-group text-align-left">
                    <div class="col-sm-12">
                      <input type="number" class="form-control" v-model="setCompletionRateValue" min="1" max="100">
                    </div>
                  </div>
                </div>
                <div class="col-lg-2 col-md-2">
                  <div class="form-group text-align-left">
                  </div>
                </div>
                <div class="create-lesson-input-text-style col-lg-1 col-md-1 text-align-right padding-right-0Px"> 
                  Automatically show certificates to Users:
                </div>
                <div class="col-lg-2 col-md-2">
                  <div class="form-group text-align-left">
                    <div class="col-sm-12">
                      <input type="checkbox" v-model="allowViewCertificateValue" :disabled="!enableDisableCertificationOption"/>
                    </div>
                  </div>
                </div>
              </div> 

              <div class="row vertical-align margin-bottom-2Perc" v-if="selectedCourseObj !== -1 && selectedCourseObj.Type !== constants.CourseType.RecommendationAssessment">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  Upload Certificate:
                </div>
                <div class="col-lg-2 col-md-2">
                  <div class="form-group text-align-left">
                    <div class="col-sm-12">
                      <input type="file" id="certificateFile" accept=".pdf" @change="enableOrDisableFileUrl" @blur="enableOrDisableFileUrl" @focus="enableOrDisableFileUrl">
                    </div>
                  </div>
                </div>
                <div class="col-lg-2 col-md-2">
                  <div class="form-group text-align-left">
                  </div>
                </div>
                <div class="create-lesson-input-text-style col-lg-1 col-md-1 text-align-right padding-right-0Px"> 
                  Certification Date:
                </div>
                <div class="col-lg-4 col-md-4">
                  <div class="form-group text-align-left">
                    <div class="col-sm-12">
                      <input type="text" class="form-control" v-model="certificationDateValue">
                    </div>
                  </div>
                </div>
                <div class="col-lg-1 col-md-1">
                </div>
              </div>

              <div class="row vertical-align margin-bottom-2Perc" v-if="selectedCourseObj !== -1 && selectedCourseObj.Type !== constants.CourseType.RecommendationAssessment">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  Enable Certification:
                </div>
                <div class="col-lg-2 col-md-2">
                  <div class="form-group text-align-left">
                    <div class="col-sm-12">
                      <input type="checkbox" v-model="enableCeritificationValue" :disabled="!enableDisableCertificationOption"/>
                    </div>
                  </div>
                </div>
                <div class="col-lg-2 col-md-2">
                  <div class="form-group text-align-left">
                  </div>
                </div>
                <div class="create-lesson-input-text-style col-lg-1 col-md-1 text-align-right padding-right-0Px"> 
                  Certificate Title:
                </div>
                <div class="col-lg-4 col-md-4">
                  <div class="form-group text-align-left">
                    <div class="col-sm-12">
                      <input type="text" class="form-control" v-model="certificateTitleValue" :maxlength="constants.Certificate_Title_Max_Length">
                    </div>
                  </div>
                </div>
                <div class="col-lg-1 col-md-1 text-align-left">
                  <div class="tooltip1">
                    <img :src="iconInfo" alt="iconCopy" class="height-20Px width-20Px img-opacity cursor-pointer">
                    <span class="tooltiptext1">{{constants.Certificate_Title_Tooltip}}</span> 
                  </div>
                </div>
              </div> 
              <!-- Personalisation -->
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  <div>
                    Enable
                  </div>
                  <div>
                    Personalization:
                  </div>
                </div>
                <div class="col-lg-4 col-md-4">
                  <div class="form-group text-align-left">
                    <div class="col-sm-12">
                      <input type="checkbox" v-model="enablePersonalizationValue"/>
                    </div>
                  </div>
                </div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px padding-Left-0px" v-if="isElective">
                  Allow Self Enrollment
                </div>
                <div class="col-lg-4 col-md-4" v-if="isElective">
                  <div class="form-group text-align-left">
                    <div class="col-sm-4">
                      <input type="checkbox" v-model="allowSelfEnrollmentValue"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
              <!-- Personalisation End -->
              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <!-- ToDo: Track this -->
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="AssociateGroup">Associate</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box> 
      <loader></loader>
 </div>
 </div>
</template>

<script scoped>
import iconInfo from '../assets/images/iconinfoblue.png'
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import { courseService } from '@/server-util/course-service'
import { groupService } from '@/server-util/group-service'
import Loader from '@/components/dashboard/Loader'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import datePicker from 'vue-bootstrap-datetimepicker'

export default {
  created: function () {
    this.getCourses()
    this.setDefaultValues()
  },
  data: function () {
    return {
      iconInfo: iconInfo,
      constants: constants,
      enableDisableCertificationOption: false,
      showAlertDialog: false,
      errorMsg: '',
      selectedGroupObj: -1,
      selectedCourseObj: -1,
      displayTitle: '',
      displaySubTitle: '',
      completionCriteriaForElective: 100,
      showSpinner: false,
      showAssociationSuccessDialog: false,
      display_title_maxLength: constants.Group_Course_Display_Title_Max_Length,
      display_sub_title_maxLength: constants.Group_Course_Display_Sub_Title_Max_Length,
      isElective: false,
      allowSelfEnrollment: false,
      disableIsElectiveCheckbox: false,
      alertMessage: null,
      releaseTS: null,
      expiryDays: null,
      isM365Course: false,
      CompletionRate: 100,
      certificationDate: '',
      enableCertification: false,
      enablePersonalization: false,
      anonymised: false,
      personalizationLevels: [],
      // personalizationLevel2: '0',
      // personalizationLevel3: '0',
      completionCriteriaTextLabel: 'Completion Criteria for Electives',
      certificateTitle: null,
      allowView: false,
      date: null,
      config: {
        format: 'MM/DD/YYYY hh:mm:ss A',
        defaultDate: null,
        useCurrent: false,
        sideBySide: true
      }
    }
  },
  name: 'AssociateGroupCourseDiv',
  methods: {
    enableOrDisableFileUrl (event) {
      var file = (this.selectedCourseObj.CourseMasterId !== constants.Default_Meeting_Mentor_Course && this.getSelectedCourseObjValue.selectedCourseObj.Type !== constants.CourseType.RecommendationAssessment) ? document.getElementById('certificateFile').files[0] : null
      if (file !== undefined && file !== 'undefined' && file !== null && file !== 'null' && file !== '') {
        this.enableDisableCertificationOption = true
      } else {
        this.enableCeritificationValue = false
        this.enableDisableCertificationOption = false
      }
    },
    setDefaultValues: function () {
      this.isElective = false
      if (this.selectedCourseObj !== undefined && this.selectedCourseObj !== null && this.selectedCourseObj !== '' && this.selectedCourseObj !== 'null' && this.selectedCourseObj !== -1) {
        var currEstTS = dmAdminUtils.getCurrentEst()
        this.isM365Course = this.selectedCourseObj.Type === constants.CourseType.M365
        if (this.isM365Course) {
          if (this.expiryDays <= 0) {
            this.expiryDays = 1
          }
          this.date = currEstTS
          this.releaseTS = currEstTS
          this.config.defaultDate = currEstTS
        } else {
          this.expiryDays = 0
          this.date = null
          this.releaseTS = null
          this.config.defaultDate = null
        }
      } else {
        this.expiryDays = 0
        this.date = null
        this.releaseTS = null
        this.config.defaultDate = null
        this.disableIsElectiveCheckbox = true
      }
    },
    updateShowAssociateGroupCourseOverlayFlag: function (event, flagToUpdate) {
      this.$emit('showAsociateGroupCourseOverlay', flagToUpdate)
    },
    getCourses: function () {
      var storeObj = this.$store
      if (storeObj.state.access_token !== undefined || storeObj.state.access_token !== '' || storeObj.state.access_token !== null) {
        // AK: Check weather Course List is already present on not
        if (storeObj.state.course_list.length === 0) {
          // this.showSpinner = true
          this.$store.state.isLoading = true
        }
        courseService.listCourses(storeObj.state.access_token)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store given course list
              storeObj.state.course_list = responseObj.data
              // AK: Hide Spinner if its showing to user
              if (this.$store.state.isLoading === true) {
                // this.showSpinner = false
                this.$store.state.isLoading = false
              }
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // AK: Hide Spinner if its showing to user
              if (this.$store.state.isLoading === true) {
                // this.showSpinner = false
                this.$store.state.isLoading = false
              }
            }
          }, errorObj => {
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            // AK: Hide Spinner if its showing to user
            if (this.$store.state.isLoading === true) {
              // this.showSpinner = false
              this.$store.state.isLoading = false
            }
          })
      } else {
        console.log('ACCESS TOKEN IS NOT FOUND HENCE DECLINE GET COURSE LIST OPERATION')
      }
    },
    AssociateGroup: function () {
      var storeObj = this.$store
      // var _this = this
      if (this.validateRequiredFieldBeforeSubmit()) {
        if (
        storeObj.state.access_token !== undefined || storeObj.state.access_token !== null || storeObj.state.access_token !== ''
        ) {
          // AK: Reset flag to false if user first select the flag and changed the preference
          if (this.isM365Course) {
            this.isElective = false
          }

          if (this.date === undefined || this.date === null || this.date === '' || this.date === 'null') {
            this.releaseTS = null
            this.expiryDays = null
          } else {
            this.releaseTS = this.date
          }
          if (this.expiryDays === undefined || this.expiryDays === null || this.expiryDays === '' || this.expiryDays === 'null' || this.expiryDays === 0) {
            this.releaseTS = null
            this.expiryDays = null
          }
          // AK: If current course is elective / M365 then set alert message as null by default
          if (this.isElective) {
            this.alertMessage = null
          } else {
            this.allowSelfEnrollment = false
          }
          if (this.certificationDateValue === undefined || this.certificationDateValue === 'undefined' || this.certificationDateValue === null || this.certificationDateValue === 'null' || this.certificationDateValue === '') {
            this.certificationDateValue = null
          }
          // AK: Start showing Spinner
          // this.showSpinner = true
          this.$store.state.isLoading = true
          var certificateFile = this.selectedCourseObj.CourseMasterId !== constants.Default_Meeting_Mentor_Course && this.selectedCourseObj.Type !== constants.CourseType.RecommendationAssessment ? document.getElementById('certificateFile').files[0] : null
          const formData = new FormData()
          formData.append('GroupId', this.selectedGroupObj.GroupId)
          formData.append('CourseMasterId', this.selectedCourseObj.CourseMasterId)
          formData.append('DisplayTitle', this.displayTitle)
          formData.append('DisplaySubTitle', this.displaySubTitle)
          formData.append('CompletionCriteriaForElective', this.completionCriteriaForElective)
          formData.append('IsElective', this.isElective)
          formData.append('AlertMessage', this.alertMessage)
          formData.append('ReleaseTS', this.releaseTS)
          formData.append('ExpiryDays', this.expiryDays)
          formData.append('AllowSelfEnrollment', this.allowSelfEnrollment)
          formData.append('CompletionRate', this.CompletionRate)
          formData.append('CertificationDate', this.certificationDate)
          formData.append('CertificateTitle', this.certificateTitle)
          formData.append('EnablePersonalization', this.enablePersonalization)
          formData.append('Anonymised', this.anonymisedValue)
          // formData.append('SupportedPersonalizationLevels', this.personalizationLevels.toString())
          formData.append('SupportedPersonalizationLevels', this.personalizationLevels.join())
          if (certificateFile === undefined || certificateFile === 'undefined' || certificateFile === null || certificateFile === 'null' || certificateFile === '' || this.selectedCourseObj.Type === constants.CourseType.RecommendationAssessment) {
            formData.append('DisableCertification', true)
            formData.append('CertificateFile', null)
            formData.append('AllowView', false)
          } else {
            formData.append('DisableCertification', !this.enableCertification)
            formData.append('CertificateFile', certificateFile)
            formData.append('AllowView', this.allowView)
          }
          groupService
            .associateGroupCourseMaster(
              storeObj.state.access_token,
              formData
            )
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                this.$emit('refreshList', true)
                // AK: Hide showing Spinner
                // this.showSpinner = false
                this.$store.state.isLoading = false
                // AK: Show success msg to user
                this.showAlertDialog = true
                this.errorMsg = '"' + this.selectedCourseObj.CourseTitle + '" successfully associated with "' + this.selectedGroupObj.GroupName + '".'
                this.showAssociationSuccessDialog = true
              } else {
                // AK: Hide Spinner
                // this.showSpinner = false
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
              }
            }, errorObj => {
              // AK: Hide Spinner
              // this.showSpinner = false
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
        } else {
          console.log(
            'Access Token is NULL hence declined CREATE NEW GROUP'
          )
        }
      }
    },
    checkCertificateFileExtesion: function (fileName) {
      var exts = ['.pdf']
      return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
        fileName
      )
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value

      // AK: Hide Create Group course association Overlay with success message if its showing to user
      if (this.showAssociationSuccessDialog) {
        this.$emit('showAsociateGroupCourseOverlay', false)
      }
    },
    validateRequiredFieldBeforeSubmit: function () {
      var pattern = /^-?\d+\.?\d*$/
      var certificateFile = (this.selectedCourseObj.CourseMasterId !== constants.Default_Meeting_Mentor_Course && this.selectedCourseObj.Type !== constants.CourseType.RecommendationAssessment) ? document.getElementById('certificateFile').files[0] : null
      if (this.selectedCourseObj === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a course.'
        return false
      } else if (this.selectedGroupObj === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a group.'
        return false
      } if (this.date === null && this.isM365Course) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a release date.'
        return false
      } else if (((this.expiryDaysValue === undefined || this.expiryDaysValue === null || this.expiryDaysValue === '' || this.expiryDaysValue === 'null') && this.isM365Course)) {
        this.showAlertDialog = true
        this.errorMsg = 'Expiry days must be a non empty digit value.'
        return false
      } else if ((this.expiryDaysValue !== undefined && this.expiryDaysValue !== null && this.expiryDaysValue !== '' && this.expiryDaysValue !== 'null' && !pattern.test(this.expiryDaysValue))) {
        this.showAlertDialog = true
        this.errorMsg = 'Expiry days must be a non empty digit value.'
        return false
      } else if (this.date === null && this.expiryDaysValue > 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a release date.'
        return false
      } else if (this.date !== null && (this.expiryDaysValue === undefined || this.expiryDaysValue === null || this.expiryDaysValue === 'null' || this.expiryDaysValue === '')) {
        this.showAlertDialog = true
        this.errorMsg = 'Expiry days must be a non empty digit value.'
        return false
      } else if (!pattern.test(this.expiryDaysValue)) {
        this.showAlertDialog = true
        this.errorMsg = 'Expiry days must be a non empty digit value.'
        return false
      } else if (this.date != null && this.expiryDaysValue <= 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Expiry days can\'t be less than 1.'
        return false
      } else if (this.date != null && this.expiryDaysValue > 999) {
        this.showAlertDialog = true
        this.errorMsg = 'Expiry days can\'t be more than 999.'
        return false
      } else if (certificateFile !== undefined && certificateFile !== 'undefined' && certificateFile !== null && !this.checkCertificateFileExtesion(document.getElementById('certificateFile').value)) {
        this.showAlertDialog = true
        this.errorMsg = 'Only .pdf file is allowed for uploading a certificate.'
        return false
      } else if ((this.certificationDateValue !== undefined && this.certificationDateValue !== null && this.certificationDateValue !== 'null' && this.certificationDateValue !== '') && (certificateFile === undefined || certificateFile === 'undefined' || certificateFile === null || certificateFile === 'null' || certificateFile === '')) {
        this.showAlertDialog = true
        this.errorMsg = 'Please upload a certificate or remove the certification date.'
        return false
      } else if ((this.certificationDateValue === undefined || this.certificationDateValue === null || this.certificationDateValue === 'null' || this.certificationDateValue === '') && (certificateFile !== undefined && certificateFile !== 'undefined' && certificateFile !== null && certificateFile !== 'null' && certificateFile !== '')) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add a certification date or remove uploaded certificate.'
        return false
      } else if ((this.certificateTitleValue !== undefined && this.certificateTitleValue !== null && this.certificateTitleValue !== 'null' && this.certificateTitleValue !== '') && (certificateFile === undefined || certificateFile === 'undefined' || certificateFile === null || certificateFile === 'null' || certificateFile === '')) {
        this.showAlertDialog = true
        this.errorMsg = 'Please upload a certificate or remove the certificate title.'
        return false
      } else if ((this.certificateTitleValue === undefined || this.certificateTitleValue === null || this.certificateTitleValue === 'null' || this.certificateTitleValue === '') && (certificateFile !== undefined && certificateFile !== 'undefined' && certificateFile !== null && certificateFile !== 'null' && certificateFile !== '')) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add a certificate title or remove uploaded certificate.'
        return false
      }
      return true
    },
    resetValueToDefault: function () {
      this.completionCriteriaForElective = 100
      this.isElective = false
      this.allowSelfEnrollment = false
      this.disableIsElectiveCheckbox = false
      this.alertMessage = null
      this.releaseTS = null
      this.expiryDays = null
      this.isM365Course = false
      this.CompletionRate = 100
      this.certificationDate = ''
      this.enableCertification = false
      this.enablePersonalization = false
      this.anonymised = false
      this.personalizationLevels = []
      this.completionCriteriaTextLabel = 'Completion Criteria for Electives'
      this.certificateTitle = null
      this.allowView = false
      this.date = null
      this.config = {
        format: 'MM/DD/YYYY hh:mm:ss A',
        defaultDate: null,
        useCurrent: false,
        sideBySide: true
      }
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader,
    'date-picker': datePicker
  },
  computed: {
    getSelectedCourseObjValue: {
      get: function () {
        return this.selectedCourseObj
      },
      set: function (newValue) {
        this.selectedCourseObj = newValue
        if (newValue.CourseMasterId === constants.Default_Meeting_Mentor_Course) {
          this.resetValueToDefault()
        }
      }
    },
    allowSelfEnrollmentValue: {
      get: function () {
        return this.allowSelfEnrollment
      },
      set: function (newValue) {
        this.allowSelfEnrollment = newValue
      }
    },
    enableCeritificationValue: {
      get: function () {
        return this.enableCertification
      },
      set: function (newValue) {
        this.enableCertification = newValue
      }
    },
    enablePersonalizationValue: {
      get: function () {
        return this.enablePersonalization
      },
      set: function (newValue) {
        this.enablePersonalization = newValue
      }
    },
    anonymisedValue: {
      get: function () {
        return this.anonymised
      },
      set: function (newValue) {
        this.anonymised = newValue
      }
    },
    personalizationLevelValue: {
      get: function () {
        return this.personalizationLevels
      },
      set: function (newValue) {
        this.personalizationLevels = newValue
      }
    },
    certificateTitleValue: {
      get: function () {
        return this.certificateTitle
      },
      set: function (newValue) {
        this.certificateTitle = newValue
      }
    },
    certificationDateValue: {
      get: function () {
        return this.certificationDate
      },
      set: function (newValue) {
        this.certificationDate = newValue
      }
    },
    setCompletionRateValue: {
      get: function () {
        return this.CompletionRate
      },
      set: function (newValue) {
        var pattern = /^-?\d+\.?\d*$/
        if (newValue !== undefined && newValue !== null && newValue !== 'null' && newValue !== '' && pattern.test(newValue)) {
          if (parseInt(newValue) <= 0) {
            this.showAlertDialog = true
            this.errorMsg = 'Completion Criteria for certificate can\'t be less than 1.'
            this.CompletionRate = 100
          } else if (parseInt(newValue) > 100) {
            this.showAlertDialog = true
            this.errorMsg = 'Completion Criteria for certificate can\'t be greater than 100.'
            this.CompletionRate = 100
          } else {
            this.CompletionRate = newValue
          }
        } else {
          this.showAlertDialog = true
          this.errorMsg = 'Completion Criteria for certificate can\'t be empty.'
          this.CompletionRate = 100
        }
      }
    },
    setCompletionCriteriaForElectivesValue: {
      get: function () {
        return this.completionCriteriaForElective
      },
      set: function (newValue) {
        var pattern = /^-?\d+\.?\d*$/
        if (newValue !== undefined && newValue !== null && newValue !== 'null' && newValue !== '' && pattern.test(newValue)) {
          if (parseInt(newValue) < 0) {
            this.showAlertDialog = true
            this.errorMsg = this.completionCriteriaTextLabel + ' can\'t be less than 0.'
            this.completionCriteriaForElective = 100
          } else if (parseInt(newValue) > 100) {
            this.showAlertDialog = true
            this.errorMsg = this.completionCriteriaTextLabel + ' can\'t be greater than 100.'
            this.completionCriteriaForElective = 100
          } else {
            this.completionCriteriaForElective = newValue
          }
        } else {
          this.showAlertDialog = true
          this.errorMsg = this.completionCriteriaTextLabel + ' can\'t be empty.'
          this.completionCriteriaForElective = 100
        }
      }
    },
    setDateValue: {
      get: function () {
        return this.date
      },
      set: function (newValue) {
        this.date = newValue
        this.config.defaultDate = newValue
        if ((this.date === null || this.date === undefined || this.date === '' || this.date === '')) {
          if (this.isM365Course) {
            setTimeout(() => {
              this.date = dmAdminUtils.getCurrentEst()
              this.config.defaultDate = dmAdminUtils.getCurrentEst()
            }, 10)
          } else {
            this.expiryDays = 0
          }
        }
      }
    },
    getGroupList: {
      get: function () {
        return this.$store.state.groupList
      }
    },
    getCourseList: {
      get: function () {
        return this.$store.state.course_list
      }
    },
    allowViewCertificateValue: {
      get: function () {
        return this.allowView
      },
      set: function (newValue) {
        this.allowView = newValue
      }
    },
    electiveCourseValue: {
      get: function () {
        return this.isElective
      },
      set: function (newValue) {
        if (newValue) {
          this.alertMessage = null
        }
        this.isElective = newValue
        this.allowSelfEnrollment = this.isElective ? this.allowSelfEnrollment : false
        this.completionCriteriaTextLabel = this.isElective ? 'Allow other electives at' : 'Completion Criteria for Electives'
      }
    },
    expiryDaysValue: {
      get: function () {
        return this.expiryDays
      },
      set: function (newValue) {
        this.expiryDays = newValue
        this.expiryDays = newValue
        var pattern = /^-?\d+\.?\d*$/
        if (newValue !== undefined && newValue !== null && newValue !== 'null' && newValue !== '' && pattern.test(newValue)) {
          if (parseInt(newValue) === 0) {
            if (this.isM365Course) {
              this.expiryDays = 1
            } else {
              this.date = null
              this.config.defaultDate = null
            }
          } else if (this.date === null) {
            this.config.defaultDate = dmAdminUtils.getCurrentEst()
            this.date = dmAdminUtils.getCurrentEst()
          }
        }
      }
    }
  },
  watch: {
    selectedCourseObj: function (newValue, oldValue) {
      if (newValue !== -1) {
        this.setDefaultValues()
        switch (newValue.Type) {
          case constants.CourseType.RecommendationAssessment:
            console.log('constants.CourseType.RecommendationAssessment')
            this.alertMessage = null
            this.isElective = false
            this.completionCriteriaForElective = 100
            this.releaseTS = null
            this.expiryDays = 0
            this.allowView = false
            this.certificateTitle = ''
            this.certificationDate = ''
            this.enableCertification = false
            this.isM365Course = false
            this.CompletionRate = 100
            break
          case constants.CourseType.M365:
            console.log('constants.CourseType.M365')
            this.disableIsElectiveCheckbox = true
            break
          default:
            console.log('default')
            this.disableIsElectiveCheckbox = false
            break
        }
      }
    }
  }
}
</script>

<style scoped>
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-1Point5Perc
{
	margin-top: 1.5%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 6%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-1Point5Perc {
  margin-right: 1.5%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 15px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
.border-red {
  border: 1px solid red;
}
.float-left {
  float: left;
}
.tooltip1 {
    position: relative !important;
    display: inline-block !important;
    /* border-bottom: 1px dotted black !important; */
}
.tooltip1 .tooltiptext1 {
    visibility: hidden;
    width: 90px;
    background-color: #696969;
    /* opacity:0.8; */
    color: #fff;
    text-align: left;
    border-radius: 6px;
    padding: 5px 5px;
    font-size: 12px;
    /* Position the tooltip */
    position: absolute;
    z-index: 1;
    top: 107%;
    left: 35%;
    margin-left: -60px;
}
.tooltip1 .tooltiptext1::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #696969 transparent;
}
.tooltip1:hover .tooltiptext1 {
    visibility: visible;
}
.height-20Px {
 height:20px; 
}
.width-20Px {
  width:20px;
}
</style>


// WEBPACK FOOTER //
// src/components/AssociateGroupCourseOverlay.vue